export const getBreakTimeTakenInSeconds = (startTime: string) => {
	const currentTime = Date.now();
	const breakStartTime = new Date(startTime).getTime();
	return Math.floor((currentTime - breakStartTime) / 1000);
};
